/* eslint-disable no-param-reassign */
/* eslint-disable react/prop-types */
import React, { useEffect, useState, useContext } from 'react';
import Select from 'react-select';
import { useHistory } from 'react-router-dom';
import { useForm, useWatch, Controller } from 'react-hook-form';
import { string, object,
 } from 'yup';
import { useTranslation } from 'react-i18next';

import {
  Button,
  Container,
  Grid,
  makeStyles,
  TextField,
  Typography,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel
} from '@material-ui/core';
import { yupResolver } from '@hookform/resolvers/yup';
import api from '../../../../service/axios/api';
import FlashContext from '../../../../components/contexts/FlashContext';
import routing from '../../../../service/routes/routing';
import { validateDocExtern } from '../../../../service/utils';

const customStyles = {
  control: provided => ({
    ...provided,
    // width: 200,
    backgroundColor: 'none',
    // boxShadow: 'none',
    boxShadow: '2px 2px 2px 1px rgba(0, 0, 0, 0.2)',
    border: 'none',
    color: '#717171',
    fontWeight: 'bold',
    fontFamily: 'Open Sans',
    // fontSize: 24,
  }),
  indicatorSeparator: () => ({ display: 'none' }),
  option: provided => ({
    ...provided,
    fontWeight: 'bold',
    fontFamily: 'Open Sans',
    color: '#717171',
    // color: state.data.color,
    // backgroundColor: state.data.bgcolor,
    // fontSize: 24,
  }),
  placeholder: () => ({
    fontWeight: 'bold',
    fontFamily: 'Open Sans',
    marginTop: -20,
    color: '#717171',
    // paddingBottom: 20,
    // fontSize: 24,
    // marginBottom: 30,
  }),
};

const useStyles = makeStyles(theme => ({
  form: {
    minHeight: '500px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  content: {
    padding: theme.spacing(4),
  },
  section: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(8),
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: theme.spacing(4),
    background: '#f0f0f0',
    width: '100%',
  },
}));

// eslint-disable-next-line no-unused-vars
function CreateContractAwardForm() {
  const { t } = useTranslation();
  const classes = useStyles();
  const history = useHistory();
  const { notifySuccess, notifyError } = useContext(FlashContext);

  const [loading, setLoading] = useState(false);
  const [optCompanies, setOptCompanies] = useState([]);
  const [contract, setContract] = useState();
  const [isValid, setIsValid] = useState(false);
  const [found, setFound] = useState(false);

  const filterPhone = (e, field) => {
    const valorDigitado = e.target.value;
    const apenasPermitidos = valorDigitado.replace(/[^0-9()\- ]/g, "");
    field.onChange(apenasPermitidos);
  }
  
  const filterNumber = (e, field) => {
    const valorDigitado = e.target.value;
    const apenasPermitidos = valorDigitado.replace(/\D/g, "");
    field.onChange(apenasPermitidos);
  }

  const checkCEP = async (e) => {
    const cep = e.target.value.replace(/\D/g, "");

    const clearAddress = () => {
      setValue("street_name", "");
      setValue("district", "");
      setValue("city", "");
      setValue("state", "");
      setValue("number", "");
      setValue("complement", "");
    };

    if (cep.length !== 8) {
      clearAddress();
      return;
    };

    try {
      const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
      const data = await response.json();

      if (data.erro) {
        clearAddress();
        return;
      }

      clearErrors("cep");
      setValue("street_name", data.logradouro);
      setValue("district", data.bairro);
      setValue("city", data.localidade);
      setValue("state", data.uf);

    } catch (error) {
      console.error(error);
      clearAddress();
    }
  };

  const IndividualSchema = object({
    tipoPessoa: string()
      .oneOf(["INDIVIDUAL", "LEGAL_ENTITY"], t('newContractAward.errors.type'))

      .required(t('newContractAward.errors.typeRequired')),
    cpf: string()
      .transform((value) => (value === "" ? null : value)) 
      .nullable()
      .when("tipoPessoa", {
        is: "INDIVIDUAL",
        then: (schema) => schema.required(t('newContractAward.errors.cpfRequired'))
          .length(11, t('newContractAward.errors.cpfLength')),
        otherwise: (schema) => schema.notRequired(),
      }),
    name: string()
      .transform((value) => (value === "" ? null : value)) 
      .nullable()
      .when("tipoPessoa", {
        is: "INDIVIDUAL",
        then: (schema) => schema.required(t('newContractAward.errors.name')),
        otherwise: (schema) => schema.notRequired(),
      }),
    cnpj: string()
      .transform((value) => (value === "" ? null : value)) 
      .nullable()
      .when("tipoPessoa", {
        is: "LEGAL_ENTITY",
        then: (schema) => 
          schema.required(t('newContractAward.errors.cnpjRequired'))
        .length(14, t('newContractAward.errors.cnpjLength')),
        otherwise: (schema) => schema.notRequired(),
      }),
    company_name: string()
      .transform((value) => (value === "" ? null : value)) 
      .nullable()
      .when("tipoPessoa", {
        is: "LEGAL_ENTITY",
        then: (schema) => schema.required(t('newContractAward.errors.name')),
        otherwise: (schema) => schema.notRequired(),
      }),
    phone: string()
      .transform((value, originalValue) => {
        if (!originalValue) return null;
        const cleanStr = originalValue.replace(/\D/g, '');
        return cleanStr === "" ? null : cleanStr;
      }) 
      .nullable()
      .notRequired()
      .length(10, t('editContractAward.errors.phone')),
     mobile: string()
      .transform((value, originalValue) => {
        if (!originalValue) return null;
        const cleanStr = originalValue.replace(/\D/g, '');
        return cleanStr === "" ? null : cleanStr;
      }) 
      .nullable()
      .notRequired()
      .length(11, t('editContractAward.errors.mobile')),
    email: string()
      .transform((value) => (value === "" ? null : value)) 
      .nullable()
      .notRequired()
      .email(t('editContractAward.errors.email')),
    whatsapp: string()
      .transform((value, originalValue) => {
        if (!originalValue) return null;
        const cleanStr = originalValue.replace(/\D/g, '');
        return cleanStr === "" ? null : cleanStr;
      }) 
      .nullable()
      .notRequired()
      .length(11, t('editContractAward.errors.mobile')),
    postal_code: string()
      .transform((value, originalValue) => {
        if (!originalValue) return null;
        const cleanStr = originalValue.replace(/\D/g, '');
        return cleanStr === "" ? null : cleanStr;
      }) 
      .nullable()
      .notRequired()
      .length(8, t('editContractAward.errors.postalCode')),
    number: string()
      .transform((value, originalValue) => {
          if (!originalValue) return null;
          const cleanStr = originalValue.replace(/\D/g, '');
          return cleanStr === "" ? null : cleanStr;
        }) 
      .nullable()
      .notRequired(),
    complement: string()
      .transform((value) => (value === "" ? null : value)) 
      .nullable()
      .notRequired(),
    district: string()
      .transform((value) => (value === "" ? null : value)) 
      .nullable()
      .notRequired(),
    city: string()
      .transform((value) => (value === "" ? null : value)) 
      .nullable()
      .notRequired(),
    state: string()
      .transform((value) => (value === "" ? null : value)) 
      .nullable()
      .notRequired(),
    care_of: string()
      .transform((value) => (value === "" ? null : value)) 
      .nullable()
      .notRequired(),
  });

  const {
    handleSubmit,
    control,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues:{
      tipoPessoa: 'INDIVIDUAL',
      cpf: null,
      name: null,
      cnpj: null,
      company_name: null,
      phone: null,
      mobile: null,
      email: null,
      whatsapp: null,
      postal_code: null,
      street_name: null,
      number: null,
      complement: null,
      district: null,
      city: null,
      state: null,
      care_of: null,
    },
    mode: "onBlur",
    resolver: yupResolver(IndividualSchema),
  });

  const tipoPessoa = useWatch({
    control,
    name: "tipoPessoa",
  });

  const mySubmit = async (data) => {
    setLoading(true);
    if(!contract){
      notifyError(t('newContractAward.errors.noContract'));
      setLoading(false);
      return;
    }
    try {
      let awardee;
      if(tipoPessoa === "INDIVIDUAL") {
        if(found){
          if(!isValid){
            notifyError(t('newContractAward.individual.invalidIndividual'))
          } else {
            awardee = await api.contract.createContractAward(contract.value, data, found)
            notifySuccess(awardee.message);
            if (history.length > 2) {
              history.goBack();
            } else {
              history.push(routing.contractAwards);
            }
          }
        } else {
          const listOk = [];
          const listNotOk = [];
          const listGeral = [];

          const validate = await api.order.consultaBeneficiario([{doc: data.cpf, name: data.name, type: "validation"}],[])

          await validateDocExtern(validate, listOk, listNotOk, listGeral)

          if(listNotOk.length > 0){
            notifyError(`${t('newContractAward.individual.validationError')} ${listNotOk[0].motivo}`)
          } else {
            awardee = await api.contract.createContractAward(contract.value, data, found)
            notifySuccess(awardee.message);
            if (history.length > 2) {
              history.goBack();
            } else {
              history.push(routing.contractAwards);
            }
          }
        }
      } else if(found){
        if(!isValid){
          notifyError(t('newContractAward.entity.invalidEntity'))
        } else {
          awardee = await api.contract.createContractAward(contract.value, data, found)
          notifySuccess(awardee.message);
          if (history.length > 2) {
            history.goBack();
          } else {
            history.push(routing.contractAwards);
          }
        }
      } else {
        const listOk = [];
        const listNotOk = [];
        const listGeral = [];

        const validate = await api.order.consultaBeneficiario([],[{doc: data.cnpj, name: data.company_name, type: "validation"}])

        await validateDocExtern(validate, listOk, listNotOk, listGeral)

        if(listNotOk.length > 0){
          notifyError(`${t('newContractAward.entity.validationError')} ${listNotOk[0].motivo}`)
        } else {
          awardee = await api.contract.createContractAward(contract.value, data, found)
          notifySuccess(awardee.message);
          if (history.length > 2) {
            history.goBack();
          } else {
            history.push(routing.contractAwards);
          }
        }
      }
      
      // const response = await api.contract.updateAwardIndividual(cancel, individual.id, data);
      
      // notifySuccess(response.message);
      // if (history.length > 2) {
      //   history.goBack();
      // } else {
      //   history.push(routing.contractAwards);
      // }
    } catch (error) {
      notifyError(error.message);
    } finally{
      setLoading(false);
    }
  }

  const handleChange = (e) => {
    setContract({
      label: e.label,
      value: e.all.id,
    });
  };

  const handleCpf = async (e, field) => {
    filterNumber(e, field)

    if(e.target.value.length === 11) {
      try {
        const res = await api.individual.getByCpf(e.target.value)

        if(res.docs.length > 0) {
          setFound(true);
          const individual = res.docs[0];
          setValue("cpf", individual.cpf);
          clearErrors("cpf");
          setValue("name", individual.name);
          clearErrors("name");

          if(individual.is_verified){
            setIsValid(true);
          } else {
            setIsValid(false);
          }
        } else {
          setFound(false);
          setIsValid(false);
        }
      } catch (error) {
        console.log(error)
      }
    } else {
      if (isValid) {
        setIsValid(false);
      }
      if (found){
        setFound(false);
      }
    }
  }
  
  const handleCnpj = async (e, field) => {
    filterNumber(e, field)

    if(e.target.value.length === 14) {
      try {
        const res = await api.legalEntities.getByCnpj(e.target.value)

        if(res.docs.length > 0) {
          setFound(true);
          const individual = res.docs[0];
          setValue("cnpj", individual.cnpj);
          clearErrors("cnpj");
          setValue("company_name", individual.company_name);
          clearErrors("company_name");

          if(individual.is_verified){
            setIsValid(true);
          } else {
            setIsValid(false);
          }
        } else {
          setFound(false);
          setIsValid(false);
        }
      } catch (error) {
        console.log(error)
      }
    } else {
      if (isValid) {
        setIsValid(false);
      }
      if (found){
        setFound(false);
      }
    }
  }

  useEffect(() => {
    setFound(false);
    setIsValid(false);
    if (tipoPessoa === "INDIVIDUAL") {
      setValue("cnpj", null);
      clearErrors("cnpj");
      setValue("company_name", null);
      clearErrors("company_name");
    } else {
      setValue("cpf", null);
      clearErrors("cpf");
      setValue("name", null);
      clearErrors("name");
      setValue("care_of", null);
      clearErrors("care_of");
      setValue("whatsapp", null);
      clearErrors("whatsapp");
    }
  }, [tipoPessoa]);

  useEffect(() => {
    if(optCompanies.length === 0){
      const cancel = new AbortController();
      const p1 = api.contract.getByProduct(cancel, 'Card');
      const p2 = api.contract.getByProduct(cancel, 'Transfer');
      Promise.all([p1, p2])
        .then(res => {
          const list = [];
          res.forEach(c => {
            c.forEach(item => {
              if (item.campaign) {
                list.push({
                  label: `${item.companyName} - ${item.campaign}`,
                  value: item.id,
                  all: item,
                });
              } else {
                list.push({
                  label: item.companyName,
                  value: item.id,
                  all: item,
                });
              }
            });
          });
          setOptCompanies(list);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, []);

  return (
    <form className={classes.form} onSubmit={
      handleSubmit(mySubmit)
      }>
      <Container className={classes.content}>
  
        <div className={classes.section}>
          <Typography variant="h5" component="h3" gutterBottom>
            {t('newContractAward.contractLabel')}
          </Typography>
          <Grid
            container
            spacing={1}
            style={{
              justifyContent: 'center',
              paddingLeft: 40,
              paddingRight: 40,
              alignItems: 'center',
              marginBottom: 40
            }}
          >
            <Grid item xs={12} sm={12}>
              <Select
                styles={customStyles}
                value={contract}
                classNamePrefix="select"
                placeholder={t('newContractAward.form.contractPlaceholder')}
                onChange={handleChange}
                options={optCompanies}
              />
            </Grid>
          </Grid>
          <Typography variant="h5" component="h3" gutterBottom>
            {t('newContractAward.awardeeLabel')}
          </Typography>
          <Grid container spacing={10}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <FormControl component="fieldset">
                <Controller
                  name="tipoPessoa"
                  control={control}
                  render={({ field }) => (
                    <RadioGroup row {...field}>
                      <FormControlLabel value="INDIVIDUAL" control={<Radio />} label={t('newContractAward.form.individual')} />
                      <FormControlLabel value="LEGAL_ENTITY" control={<Radio />} label={t('newContractAward.form.entity')} />
                    </RadioGroup>
                  )}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              {tipoPessoa === "INDIVIDUAL" ? (
                <Controller 
                  key="cpf-field"
                  name="cpf"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      label={t('newContractAward.form.cpf')}
                      onChange={(e) => handleCpf(e, field)}
                      variant="outlined"
                      fullWidth
                      size="small"
                      error={!!errors.cpf}
                      helperText={errors.cpf?.message}
                      InputLabelProps={{ shrink: !!field.value }}
                    />
                  )}
                />
              ) : (
                <Controller 
                  key="cnpj-field"
                  name="cnpj"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      label={t('newContractAward.form.cnpj')}
                      onChange={(e) => handleCnpj(e, field)}
                      variant="outlined"
                      fullWidth
                      size="small"
                      error={!!errors.cnpj}
                      helperText={errors.cnpj?.message}
                      InputLabelProps={{ shrink: !!field.value }}
                    />
                  )}
                />
              )}
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              {tipoPessoa === "INDIVIDUAL" ? (
                <Controller 
                  key="name-field"
                  name="name"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      label={t('newContractAward.form.name')}
                      disabled={found}
                      variant="outlined"
                      fullWidth
                      size="small"
                      error={!!errors.name}
                      helperText={errors.name?.message}
                      InputLabelProps={{ shrink: !!field.value }}
                    />
                  )}
                />
              ) : (
                <Controller 
                  key="company_name-field"
                  name="company_name"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      label={t('newContractAward.form.name')}
                      disabled={found}
                      variant="outlined"
                      fullWidth
                      size="small"
                      error={!!errors.company_name}
                      helperText={errors.company_name?.message}
                      InputLabelProps={{ shrink: !!field.value }}
                    />
                  )}
                />
              )}
            </Grid>
            {
              tipoPessoa === "INDIVIDUAL" && (
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <Controller 
                    name="care_of"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        label={t('editContractAward.individual.careOf')}
                        variant="outlined"
                        fullWidth
                        size="small"
                        error={!!errors.care_of}
                        helperText={errors.care_of?.message}
                        InputLabelProps={{ shrink: !!field.value }}
                      />
                    )}
                  />
                </Grid>
              )
            }
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Controller 
                name="email"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label={t('editContractAward.email')}
                    variant="outlined"
                    fullWidth
                    size="small"
                    placeholder={t('editContractAward.placeholders.email')}
                    error={!!errors.email}
                    helperText={errors.email?.message}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Controller 
                name="phone"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    inputProps={{ inputMode: "numeric" }}
                    onChange={(e) => filterPhone(e, field)}
                    label={t('editContractAward.phone')}
                    variant="outlined"
                    fullWidth
                    size="small"
                    placeholder={t('editContractAward.placeholders.phone')}
                    error={!!errors.phone}
                    helperText={errors.phone?.message}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Controller 
                name="mobile"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    inputProps={{ inputMode: "numeric" }}
                    onChange={(e) => filterPhone(e, field)}
                    label={t('editContractAward.mobile')}
                    variant="outlined"
                    fullWidth
                    size="small"
                    placeholder={t('editContractAward.placeholders.mobile')}
                    error={!!errors.mobile}
                    helperText={errors.mobile?.message}
                  />
                )}
              />
            </Grid>
            {
              tipoPessoa === "INDIVIDUAL" && (
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <Controller 
                    name="whatsapp"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        inputProps={{ inputMode: "numeric" }}
                        onChange={(e) => filterPhone(e, field)}
                        label={t('editContractAward.individual.whatsapp')}
                        variant="outlined"
                        fullWidth
                        size="small"
                        placeholder={t('editContractAward.placeholders.mobile')}
                        error={!!errors.whatsapp}
                        helperText={errors.whatsapp?.message}
                        InputLabelProps={{ shrink: !!field.value }}
                      />
                    )}
                  />
                </Grid>
              )
            }
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Controller 
                name="postal_code"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    inputProps={{ inputMode: "numeric" }}
                    onChange={(e) => {
                      field.onChange(e);
                      checkCEP(e);
                    }}
                    label={t('editContractAward.postalCode')}
                    variant="outlined"
                    fullWidth
                    size="small"
                    placeholder={t('editContractAward.postalCode')}
                    error={!!errors.postal_code}
                    helperText={errors.postal_code?.message}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Controller 
                name="street_name"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label={t('editContractAward.street')}
                    variant="outlined"
                    fullWidth
                    size="small"
                    InputLabelProps={{ shrink: !!field.value }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Controller 
                name="number"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    onChange={(e) => filterNumber(e, field)}
                    label={t('editContractAward.number')}
                    variant="outlined"
                    fullWidth
                    size="small"
                    error={!!errors.number}
                    helperText={errors.number?.message}
                    InputLabelProps={{ shrink: !!field.value }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Controller 
                name="complement"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label={t('editContractAward.complement')}
                    variant="outlined"
                    fullWidth
                    size="small"
                    error={!!errors.complement}
                    helperText={errors.complement?.message}
                    InputLabelProps={{ shrink: !!field.value }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Controller 
                name="district"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label={t('editContractAward.district')}
                    variant="outlined"
                    fullWidth
                    size="small"
                    InputLabelProps={{ shrink: !!field.value }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Controller 
                name="city"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label={t('editContractAward.city')}
                    variant="outlined"
                    fullWidth
                    size="small"
                    InputLabelProps={{ shrink: !!field.value }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Controller 
                name="state"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label={t('editContractAward.state')}
                    variant="outlined"
                    fullWidth
                    size="small"
                    InputLabelProps={{ shrink: !!field.value }}
                  />
                )}
              />
            </Grid>
          </Grid>
        </div>
      </Container>
      <div className={classes.footer}>
        <Button type="submit" disabled={loading} variant="contained" color="primary">
          {t('newContractAward.submit')}
        </Button>
      </div>
    </form>
      
  );
}

export default CreateContractAwardForm;
